import useNamespacedStorage from 'app/hooks/storage/useNamespacedStorage';

export const usePersistedLocation = () => {
  return useNamespacedStorage('ostroPersistedLocation', '');
};
